import {assert} from 'Asserts';
import {DataFrame, DataFrameColumnDef, DataFrameRow} from 'data-frames/DataFrameTypes';
import isSystemColumn from 'data-frames/util/isSystemColumn';
import {JSONValue} from 'util/Types';

import findColumn from './findColumn';

/**
 * Adds a column to a data frame.
 *
 * In the resulting data frame, system columns are placed at the end.
 *
 * @param dataFrame Data frame to append a column to
 * @param newColumnDefinition Definition for new column
 * @param generateColumnValue Function to generate values for the new column
 * @throws Error if the column already exists
 */
export default function addColumn(
  dataFrame: DataFrame,
  newColumnDefinition: DataFrameColumnDef,
  generateColumnValue: (row: DataFrameRow, index: number) => JSONValue
): DataFrame {
  assert(!findColumn(dataFrame, newColumnDefinition.systemName), 'New column already exists.', {
    newColumnDefinition,
    existingColumns: dataFrame.columns,
  });

  return {
    ...dataFrame,
    columns: [
      ...dataFrame.columns.filter((col) => !isSystemColumn(col)),
      newColumnDefinition,
      ...dataFrame.columns.filter((col) => isSystemColumn(col)),
    ],
    rows: dataFrame.rows.map((row, index) => ({
      ...row,
      [newColumnDefinition.systemName]: generateColumnValue(row, index),
    })),
  };
}
